define('Components/BannerWidget/js/views/BannerWidgetInstanceView',['jquery','app','WidgetInstanceView',
        'InternalLinkView',
        'LazyLoad',
        'template!Components/BannerWidget/templates/default',
        'template!Components/BannerWidget/templates/time-delay',
        'template!Components/BannerWidget/templates/default2',
        'template!Components/BannerWidget/templates/banner-v2',
        'template!Components/BannerWidget/templates/banner-v3',
        'template!Components/BannerWidget/templates/default_link_bg',
        'template!Components/BannerWidget/templates/image-seo'
    ],
    function($,app,WidgetInstanceView,
             InternalLinkView,
             LazyLoad,
             defaultTemplate,
             timeDelayTemplate,
             defaultTemplateWithoutClock,
             bannerV2Template,
             bannerV3Template,
             defaultTemplateLinkBg,
             imageSeoTemplate
    ){

    // template association
    var _TEMPLATES_ = {
        "default": defaultTemplate,
        "default2": defaultTemplateWithoutClock,
        "banner-v2": bannerV2Template,
        "banner-v3": bannerV3Template,
        "time-delay": timeDelayTemplate,
        "default_link_bg": defaultTemplateLinkBg,
        "image-seo": imageSeoTemplate
    };

    return WidgetInstanceView.extend({
        name:'BannerWidgetInstanceView',
        getTemplate:function(){
            return _TEMPLATES_[this.model.getTemplate()];
        },
        afterRender:function(){
            var view = this;
            view.listenTo(app,'change:scrollTop',view.onScroll);
            InternalLinkView.initializeLinksOfView(this);
            LazyLoad(view.$('.lazyload'));
        },
        onScroll: function(){
            var view = this;
            if(!view.$el.hasClass('active')) {
                if(app.get('scrollTop') > view.$el.offset().top - app.get('winH') + view.$el.height()){
                    view.$('.centered').addClass('active');
                }
            }
        }
    })
});
